import React, { Suspense } from 'react';
import IdleTimer from 'react-idle-timer';
import Navigator from 'scenes';
import Popup from 'components/popup';
import Loader from 'components/loader';

export default class App extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      timeout: 1000 * 30 * 1,
      isTimedOut: false,
    };

    this.idleTimer = null;
    this.onActive = this._onActive.bind(this);
    this.onIdle = this._onIdle.bind(this);
  }

  componentDidMount() {
    document.documentElement.lang = localStorage.getItem('language') || 'fr';
  }

  _onIdle() {
    const { isTimedOut } = this.state;
    if (isTimedOut) {
      window.location.assign('https://www.almoukawilchaabi.ma/borne');
    } else {
      this.idleTimer.reset();
      this.setState({ isTimedOut: true });
    }
  }

  _onActive() {
    this.setState({ isTimedOut: false });
  }

  render() {
    const { timeout } = this.state;
    return (
      <div>
        <Popup />
        <Loader />
        <IdleTimer
          ref={(ref) => {
            this.idleTimer = ref;
          }}
          element={document}
          onActive={this.onActive}
          onIdle={this.onIdle}
          onAction={this.onAction}
          debounce={250}
          timeout={timeout}
        >
          <Navigator />
        </IdleTimer>
      </div>
    );
  }
}
